import { useStore } from '../../../app/data/root.store';
import { debounce } from '../../../../common/utils/functions.utils';
import { useState, useEffect, useRef } from 'react';
import { InstitutionItemSwitcherWrapper, InstitutionItemWrapper, InstitutionLogoWrapper, InstitutionName, InstitutionsResultsListWrapper, InstitutionTextWrapper, InstitutionUrl, ListAndLoaderWrapper, LoadMoreLoaderWrapper, LogoPlaceHolder, SearchingLoaderWrapper } from '../../../add-item/components/steps/addItemInstitutionStep.styles';
import { createPortal } from 'react-dom';
import { InstitutionPlaceholderIcon } from '../../../../assets/icons/common/common-icons';
import { CommonBadge } from '../../../../common/components/CommonBadge/CommonBadge';
import { highlightSearchTerm } from '../../../add-item/components/InstitutionSearchInputAndResults';
import { cleanURL } from '../../../../common/utils/string.utils';
import { observer } from 'mobx-react';
import { LogoLoader } from '../../../../common/components/LogoLoader/LogoLoader';
import { InstitutionNameField } from './ReviewTableFields';


const inputSearchDebounce = debounce((cb) => { cb() }, 100);

export const InstitutionField = observer(({ value = '', handleFieldChange, handleFundNameChange, isEdited, isHoverOn, isNew, showSkeleton }) => {

    const [isInstitutionDrawerOpen, setIsInstitutionDrawerOpen] = useState(false);
    const [institutionDrawerPosition, setInstitutionDrawerPosition] = useState({ top: 0, left: 0 });
    const institutionNameFieldRef = useRef(null);
    const { createItemStore } = useStore();
    //const [inputVal, setInputVal] = useState(value ?? '');

    useEffect(() => {
        if (!isInstitutionDrawerOpen) return;

        const handleClickOutside = (event) => {
            // If the dropdown is open and the click is outside the dropdown and the input
            if (
                institutionNameFieldRef.current &&
                !institutionNameFieldRef.current.contains(event.target)
            ) {
                setIsInstitutionDrawerOpen(false);
            }
        };

        document.addEventListener('mouseup', handleClickOutside);

        return () => {
            document.removeEventListener('mouseup', handleClickOutside);
        };
    }, [isInstitutionDrawerOpen]);

    useEffect(() => {
        if (isInstitutionDrawerOpen && institutionNameFieldRef.current) {
            const rect = institutionNameFieldRef.current.getBoundingClientRect();
            setInstitutionDrawerPosition({ top: rect.bottom + window.scrollY, left: rect.left + window.scrollX });
        }
    }, [isInstitutionDrawerOpen]);

    const handleInstitutionNameFocus = () => {
        if (isInstitutionDrawerOpen) return;

        createItemStore.searchForInst(value);
        setIsInstitutionDrawerOpen(true);
    };

    const handleChange = (e) => {
        const str = e.target.value;
        handleFieldChange(str);

        createItemStore.setIsSearchingInstitutions(true);
        inputSearchDebounce(() => createItemStore.searchForInst(str))
    }

    const handleInstitutionDrawerClick = (e, inst) => {
        e.stopPropagation();

        handleFundNameChange(inst.name);
        createItemStore.setIsSearchingInstitutions(false);
        setIsInstitutionDrawerOpen(false);
    }

    return (
        <>
            <div
                onFocus={handleInstitutionNameFocus}
                ref={institutionNameFieldRef}
            >
                <InstitutionNameField
                    value={value}
                    onChange={handleChange}
                    isEdited={isEdited}
                    isHoverOn={isHoverOn}
                    isNew={isNew}
                    showSkeleton={showSkeleton}
                />
            </div>

            <InstitutionDrawer
                isOpen={isInstitutionDrawerOpen}
                position={institutionDrawerPosition}
                searchTerm={value}
                onClick={handleInstitutionDrawerClick}
                searchedInstitutions={createItemStore.searchedInstitutions}
                isSearchingInstitutions={createItemStore.isSearchingInstitutions}
                isLoadingMoreInstitutions={createItemStore.isLoadingMoreInstitutions}
            />
        </>
    )
})

const InstitutionDrawer = ({ isOpen, position: { top, left }, searchedInstitutions, isSearchingInstitutions, isLoadingMoreInstitutions, searchTerm, onClick }) => {
    if (!isOpen || searchedInstitutions.length === 0) return null;

    return (
        createPortal((
            <ListAndLoaderWrapper style={{ position: 'fixed', top, left, width: '500px', height: '400px', zIndex: 9000 }}>
                <InstitutionsResultsListWrapper>
                    <InstitutionItemSwitcherWrapper>
                        {
                            searchedInstitutions.map(inst => (
                                <InstitutionRow
                                    item={inst}
                                    onClick={onClick}
                                    searchTerm={searchTerm}
                                />
                            ))
                        }
                    </InstitutionItemSwitcherWrapper>
                    {isLoadingMoreInstitutions &&
                        <LoadMoreLoaderWrapper>
                            <LogoLoader wbg />
                        </LoadMoreLoaderWrapper>}
                </InstitutionsResultsListWrapper>
                {isSearchingInstitutions && <SearchingLoaderWrapper >
                    <LogoLoader wbg />
                </SearchingLoaderWrapper>}
            </ListAndLoaderWrapper>
        )
            , document.body)
    );
}

const InstitutionRow = ({ item, onClick, searchTerm }) => {
    return (
        <InstitutionItemWrapper onMouseUp={(e) => onClick(e, item)} >
            <InstitutionLogoWrapper>
                {
                    item.logoBase64 ? <img alt={item.name} src={'data:image/png;base64,' + item.logoBase64} /> :
                        item.logoURL ? <img alt={item.name} src={item.logoURL} /> :
                            <LogoPlaceHolder >
                                <InstitutionPlaceholderIcon />
                            </LogoPlaceHolder>
                }
            </InstitutionLogoWrapper>
            <InstitutionTextWrapper>
                <InstitutionName>{highlightSearchTerm(item.name, searchTerm)}</InstitutionName>
                <InstitutionUrl>{cleanURL(item.homeURL)}</InstitutionUrl>
                {item.notSupported && <CommonBadge isCTA
                    badgeType={'notSupported'}
                    badgeWrapperStyle={item.notSupported ? { marginLeft: '0px', marginTop: '4px', height: '18px' } : {}}
                    tooltipContent={
                        `${item.name} isn't available for syncing yet, but you can add it manually.\n\nJoin the waiting list to be notified when auto-syncing becomes available!`}
                    color={'#DEB482'} />}
            </InstitutionTextWrapper>
        </InstitutionItemWrapper>
    )
}